import { relationships } from "@rocicorp/zero";
import { user } from "./user";
import { vehicle } from "./vehicle";
import { vehicleAssignmentsPlan } from "./vehicle-assignment-plan";

export const vehicleAssignmentPlanRelationships = relationships(
	vehicleAssignmentsPlan,
	({ one }) => ({
		vehicle: one({
			sourceField: ["vehicleId"],
			destField: ["id"],
			destSchema: vehicle,
		}),
		user: one({
			sourceField: ["userId"],
			destField: ["id"],
			destSchema: user,
		}),
	}),
);
